<div class="industries-container">
  <p class="section-label">{{ 'industries.section_label' | translate }}</p>
  <h2 class="section-title">{{ 'industries.section_title' | translate }}</h2>
  <p class="section-description">{{ 'industries.section_description' | translate }}</p>

  <div class="industries-grid">
    <img
      class="about-illustration"
      src="../assets/SkillCardsGrid.png"
      [alt]="'login_page.hero_image_alt' | translate"
    />
  </div>
</div>
